<template>
	<div class="page">
		<template v-if="isEmptyHistoryList">
			<div class="row">
				<div class="col-sm-8">
					<div class="item-history__multicheckbox">
						<div class="item-history__multicheckbox_label">{{ $t('filter.attributes') }}</div>
						<div class="item-history__multicheckbox_editor">
							<div class="multicheckbox-editor" id="item-history__multicheckbox" max-count="-1">
								<div tabindex="0" class="attribute-editor mcb-drop-down-btn fa fa-list-ul"></div>
								<div class="mcb-item-list">
									<div class="mcb-controls">
										<div class="mcb-clear" tabindex="0"></div>
										<input class="mcb-search" type="text" tabindex="-1">
										<button class="button_reset fa fa-times" tabindex="-1"></button>
									</div>
									<list-attribute></list-attribute>
									<ul class="checkbox-sublist"></ul>
								</div>
							</div>
						</div>
					</div>
					<div class="item-history__selected-attributes">
						<span v-for="(value, index) in filterArray" :key="index">{{ $t(itemStructure[value].title) + ',' }}</span>
					</div>
				</div>
				<div class="col-sm-4">
					<div class="item-history__sort">
						<select v-model="selectedSortAttribute" class="select attribute-editor">
							<option v-for="(value, key, index) in renderHistoryList[0]" :value="key" :key="index">{{ key
								}}
							</option>
						</select>
						<span class="item-history__sort_icon" :uk-icon="sortIcon" @click="sort"></span>
					</div>
				</div>
			</div>
			<template v-if="isVisibleHistoryItems">
				<div class="item-history" v-for="value in historyList" :key="value.version_number">
					<div class="row">
						<div class="col-xs-3 col-sm-3">
							<div class="item-history__description">
								<p class="item-history__description_version">{{$t('version') + ': ' +
									value.version_number }}</p>
								<p class="item-history__description_date">{{ new
									Date(value.updated).toISOString().slice(0, 10) }}</p>
								<p class="item-history__description_date">{{ new
									Date(value.updated).toLocaleTimeString() }}</p>
								<p class="item-history__description_name">{{ value.updater.firstName + ' ' +
									value.updater.lastName}}</p>
								<p class="item-history__description_login">{{ value.updater.login }}</p>
							</div>
						</div>
						<div class="col-xs-9 col-sm-9">
							<div class="item-history__attributes" v-for="(before, key, index) in value.before"
								 :key="index">
								<div class="row">
									<div class="col-sm-5">
										<p class="item-history__attributes_name">
											{{ key }}
											<i v-if="!!itemStructure[key].expression"
											   class="fa fa-calculator"
											   aria-hidden="true"/>
										</p>
									</div>
									<div class="col-sm-3">
										<p class="item-history__attributes_before" v-html="visibleValue(before, key)"></p>
									</div>
									<div class="col-sm-1">
										&#8594;
									</div>
									<div class="col-sm-3">
										<p class="item-history__attributes_after"
										   v-html="visibleValue(value.after[key], key)"></p>
									</div>
								</div>
							</div>
							<div class="item-history__button">
								<button @click="buttonManager(value.id, 'change', 'rollback')">
									<span uk-icon="rollback"></span>
									<span class="item-history__button-text">{{ $t('rollback.change') }}</span>
								</button>
								<button @click="buttonManager(value.id, 'state', 'apply')">
									<span uk-icon="check"></span>
									<span class="item-history__button-text">{{ $t('apply.state') }}</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div class="item-history__pagination">
					<a href="#" class="prev" @click="clickLinkPagination(currentPage - 1)"></a>
					<div v-if="(countPage <= (5 + 3)) && (currentPage < (5 + 3))">
						<a href="#" @click="clickLinkPagination(index)" :class="index === currentPage ? 'current': ''"
						   v-for="index in countPage" :key="index">{{ index }}</a>
					</div>
					<div v-else-if="(countPage > 5) && (currentPage < 5)">
						<template v-for="index in countPage">
							<a href="#" @click="clickLinkPagination(index)"
							   :class="index === currentPage ? 'current': ''"
							   v-if="index <= 5">{{ index }}</a>
						</template>
						<span>...</span>
						<a href="#" @click="clickLinkPagination(countPage)">{{ countPage }}</a>
					</div>
					<div v-else-if="(currentPage > (countPage - 5)) && (currentPage >= (5 + 3))">
						<a href="#" @click="clickLinkPagination(1)">1</a>
						<span>...</span>
						<template v-for="index in countPage">
							<a href="#" @click="clickLinkPagination(index)"
							   :class="index === currentPage ? 'current': ''"
							   v-if="index >= (countPage - 5)">{{ index }}</a>
						</template>
					</div>
					<div
						v-else-if="((currentPage >= 5) && (currentPage <= (countPage - 5))) && ((currentPage + 5) <= countPage)">
						<a href="#" @click="clickLinkPagination(1)">1</a>
						<span>...</span>
						<template v-for="index in countPage">
							<a href="#" @click="clickLinkPagination(index)"
							   :class="index === currentPage ? 'current': ''"
							   v-if="(index > (currentPage - 3)) && (index < (currentPage + 3))">{{ index }}</a>
						</template>
						<span>...</span>
						<a href="#" @click="clickLinkPagination(countPage)">{{ countPage }}</a>
					</div>
					<a href="#" @click="clickLinkPagination(currentPage + 1)" class="next"></a>
				</div>
			</template>
			<template v-else>
				<p>{{ $t('no.change.history.for.selected.attributes') }}</p>
			</template>
		</template>
		<template v-else>
			<div>{{ $t('history.is.empty') }}</div>
		</template>
	</div>
</template>

<script>
import http from 'utils/http'
import { showMessageAlert } from '@/core/shared'
import { bindResetButton } from '@/core/input_controls/button/button'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'

export default {
	name: 'ItemHistory',
	data () {
		return {
			historyList: [],
			historyIds: [],
			localization: {},
			languages: [],
			itemStructure: {},
			filterArray: [],
			itemId: null,
			countOnePage: 10,
			currentPage: null,
			isVisibleHistoryItems: true,
			asc: false,
			sortIcon: 'chevron-down',
			defaultAttrSorting: 'version_number'
		}
	},
	computed: {
		countPage: function () {
			return Math.ceil(this.historyIds.length / this.countOnePage) || null
		},
		renderHistoryList: {
			get () {
				return this.historyList
			},
			set (newValue) {
				this.historyList = newValue
			}
		},
		isEmptyHistoryList: function () {
			return this.renderHistoryList.length !== 0
		},
		selectedSortAttribute: {
			get () {
				return this.defaultAttrSorting
			},
			set (newValue) {
				let vm = this
				this.loadFilterIds(this.filterArray || [], newValue, this.asc).then(function (ids) {
					vm.loadHistoryToIds(ids.slice(0, 10))
					vm.currentPage = 1
					vm.defaultAttrSorting = newValue
				})
			}
		}
	},
	methods: {
		clickLinkPagination: function (index) {
			if ((index <= this.countPage) && (index > 0)) {
				this.currentPage = index
				let ids = this.historyPatrsIds(index)
				this.loadHistoryToIds(ids)

				document.getElementsByClassName('change-history-container')[0].scrollTo(0, 0)

			}
		},
		historyPatrsIds: function (index) {
			let subarray = []
			for (let i = 0; i < this.countPage; i++) {
				subarray[i] = this.historyIds.slice((i * this.countOnePage), (i * this.countOnePage) + this.countOnePage)
			}
			return subarray[index - 1]
		},
		loadHistoryToIds: function (ids) {
			let vm = this
			http.post(`${window.urlContext}items/${this.itemId}/history/difference/load`, 'ids=' + JSON.stringify(ids), {
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
			}).then(function (res) {
				vm.renderHistoryList = res.data
			}).catch(function (error) {
				showMessageAlert('error', 'danger', error.response.data)
			})
		},
		loadFilterIds: function (attributesArray, attr = this.selectedSortAttribute, asc = this.asc) {
			let vm = this
			let data = attributesArray.length !== 0 ? {
				'changed_attributes': { 'val': attributesArray }
			} : {}
			return http.post(`${window.urlContext}items/${this.itemId}/history/ids`, data, {
				headers: { 'Content-Type': 'application/json' }
			}).then(function (res) {
				return http.post(`${window.urlContext}items/${vm.itemId}/history/sort`, 'ids=' + JSON.stringify(res.data) + '&attr=' + attr + '&asc=' + asc, {
					headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
				}).then(function (res) {
					vm.historyIds = res.data
					vm.isVisibleHistoryItems = true
					return res.data.length !== 0 ? res.data : []
				}).catch(function (error) {
					showMessageAlert('error', 'danger', error.response.data)
				})
			}).catch(function (error) {
				showMessageAlert('error', 'danger', error.response.data)
			})
		},
		buttonManager: function (historyItemId, action, state) {
			let url = `${window.urlContext}items/history/${action}/${state}`
			http.post(url, `id=${historyItemId}`, {
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
			}).then(function (res) {
				location.reload()
			}).catch(function (error) {
				showMessageAlert('error', 'danger', error.response.data)
			})
		},
		filter: function (value) {
			let vm = this
			let array = this.filterArray.slice()
			if (array.indexOf(value) === -1) {
				array.push(value)
			} else {
				array.splice(array.indexOf(value), 1)
			}
			this.$set(this, 'filterArray', array)
			let arrayIds = this.loadFilterIds(this.filterArray)
			arrayIds.then(function (ids) {
				if (ids.length !== 0) {
					vm.historyIds = ids
					vm.loadHistoryToIds(ids.slice(0, 10))
				} else {
					if (vm.filterArray.length !== 0) {
						vm.isVisibleHistoryItems = false
					} else {
						vm.renderHistoryList = vm.historyPatrsIds(vm.loadFilterIds([]).then())
					}
				}
			})
		},
		sort: function () {
			let vm = this
			this.loadFilterIds(this.filterArray || [], this.defaultAttrSorting, !this.asc).then(function (ids) {
				vm.loadHistoryToIds(ids.slice(0, 10))
				vm.asc = !vm.asc
				if (vm.asc) {
					vm.sortIcon = 'chevron-up'
				} else {
					vm.sortIcon = 'chevron-down'
				}
			})
		},
		visibleValue: function (value, key) {
			if (typeof value === 'boolean') {
				return value ? 'true' : false
			} else if (value === null) {
				return ''
			} else if (value === 0) {
				return 0
			} else if (Object.prototype.toString.call(value) === '[object Array]') {
				let res = ''
				for (let i = 0; i < value.length; i++) {
					if (value[i].hasOwnProperty('val') || value[i].hasOwnProperty('mu')) {
						res += value[i].val + ' ' + value[i].mu + '<br/>'
					} else {
						res += value[i] + '<br/>'
					}
				}
				return res
			} else if (Object.prototype.toString.call(value) === '[object Object]') {
				let res = ''
				if (value.hasOwnProperty('val') || value.hasOwnProperty('mu')) {
					res += value.val + ' ' + value.mu + '<br/>'
				} else {
					for (let i = 0; i < this.languages.length; i++) {
						if (value[this.languages[i]] && !this.itemStructure[key].format) {
							res += this.languages[i] + ' ' + value[this.languages[i]] + '<br/>'
						}
						if (value[this.languages[i]] && this.itemStructure[key].format === 'RICH_TEXT') {
							res += `${this.languages[i]}
									<div class="rich-text-view">
										<div class="rich-text-editor-default">
										${value[this.languages[i]]}
										</div>
									</div>`
						}
					}
				}
				return res
			} else {
				if (this.itemStructure[key].format === 'RICH_TEXT') {
					return `<div class="rich-text-view">
						<div class="rich-text-editor-default">
						${value}
						</div>
					</div>`
				} else {
					return value
				}
			}
		}
	},
	mounted () {
		let vm = this
		enableMulticheckboxSupport({
			selector: '#item-history__multicheckbox',
			updateCallback: function (value) {
				vm.filter(value[0].value)
			},
			clearCallback: function () {
				vm.filterArray = []
				vm.loadFilterIds([]).then(function (ids) {
					vm.loadHistoryToIds(ids.slice(0, 10))
				})
				vm.isVisibleHistoryItems = true
			}
		})
		bindResetButton()
	}
}
</script>

<style scoped lang="scss">
	@mixin font-awesome-icon {
		display: inline-block;
		font-family: FontAwesome;
		font-style: normal;
		font-weight: 400;
		line-height: 1;
		-webkit-font-smoothing: antialiased;
	}

	.item-history {
		font-size: 12px;
		margin-bottom: 20px;
		padding-right: 15px;
		padding-left: 15px;
		border: 1px solid #cccccc;

		[class*='col-'] {
			padding-right: 0;
			padding-left: 0;
		}

		&__selected-attributes {
			text-align: left;
			font-size: 13px;
			margin-bottom: 10px;

			span {
				margin-right: 5px;
			}
		}

		&__multicheckbox {
			display: inline-flex;
			align-items: center;
			width: 100%;
			font-size: 14px;
			margin: 15px 0 0 0;
		}

		&__sort {
			margin: 15px 0;
			text-align: right;
			display: flex;

			&_icon {
				border: 1px solid #cccccc;
				line-height: 23px;
				margin-left: 5px;

				&:hover {
					cursor: pointer;
					border: 1px solid darken(#cccccc, 5%);
				}
			}
		}

		&__description {
			text-align: left;
			padding: 5px;

			&_version {
				color: #0090D0;
				margin: 0 0 5px 0;
				font-weight: 600;
			}

			&_date {
				margin: 5px 0;
				font-size: 12px;
			}

			&_name {
				margin-bottom: 0;
			}

			&_login {
				margin: 2px 0 0 0;
			}
		}

		&__button {
			margin: 10px 5px 0 5px;
			text-align: right;

			&-text {
				line-height: 26px;
			}

			button {
				min-width: 130px;
				background-color: #fff;
				line-height: 23px;
				height: 30px;
				border: 1px solid #ccc;
				margin-bottom: 5px;

				&:hover {
					color: #0090D0;
				}
			}
		}

		&__attributes {
			background-color: #f8f8f8;
			margin: 5px;
			padding: 5px;
			border-left: 1px solid #cccccc;

			p {
				margin: 0;
				text-align: left;
				@media only screen and (max-width: 768px) {
					margin: 5px;
				}

				&:first-child {
					@media only screen and (max-width: 768px) {
						margin-bottom: 10px;
					}
				}
			}

			&_name {
				color: #333;
			}

			&_before {
				color: #f0506e;
			}

			&_after {
				color: #0f9d58;
			}

			.row {
				margin: 0;
			}
		}

		&__pagination {
			margin: auto 0;

			* {
				color: #999999;
				cursor: pointer;
				margin: 0 2px;
				padding: 0 2px;
				display: inline-block;
				transition: .2s;

				&:first-child,
				&:last-child {
					font-size: 14px;

					&:hover {
						color: #4A4A4A;
						font-weight: 600;
					}
				}
			}

			a {
				text-decoration: none;
				font-size: 14px;

				&:hover {
					color: #4A4A4A;
					font-weight: 600;
				}
			}

			span {
				cursor: default;
			}

			.prev {
				cursor: pointer;

				&:after {
					@include font-awesome-icon;
					content: "\f104";
				}
			}

			.next {
				cursor: pointer;

				&:before {
					@include font-awesome-icon;
					content: "\f105";
				}
			}

			.current {
				color: #4A4A4A;
				font-weight: 600;
			}
		}
	}
	.multicheckbox-editor .mcb-drop-down-btn {
		line-height: 3px;
		margin-left: 5px;
	}
</style>
